import styled from 'styled-components';

export const ContentWrapper = styled.div`
  padding: 30px 20px 0 20px;
  width: 100%;
`;

export const Divider = styled.div`
  margin: ${({ margin = '30px 0 30px -20px' }) => margin};
  width: ${({ w = 'calc(100% + 40px)' }) => w};
  height: 0.5px;
  background-color: #ff7828;
  opacity: 0.3;
`;
